// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/profilecard/index.scss
// module id = 2562
// module chunks = 13